import React, { useState, useEffect } from 'react'
import db from '../firebase/config'
import { Container, Col, Row } from 'reactstrap'
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';


const SetupMain = () => {

    const [setups, setSetups] = useState([]);

    useEffect(() => {
        db.collection("setup").onSnapshot((snapshot) =>
            setSetups(snapshot.docs.map((doc) => doc.data())))
    }, [])

    return (
        <>
            <div className="setupMain">
                {setups.map((setup) => (
                    <div className="setupImage">
                        <img src={setup.image} alt="setup images" />
                    </div>
                ))}
                <Container>
                    <Row>
                        <Col md="8">
                            <div className="mySetup">
                                <span className="laptopSpecs">
                                    <ul>
                                        <a href="https://www.apple.com/mac/compare/?modelList=MacBook-Air-M1,MacBookPro-13-M1,MacBookPro-16" target="_blank">
                                            <h2>MacBook Pro 16</h2> <ArrowUpwardIcon />
                                        </a>
                                        <li>Intel Core i9 processor 8-core </li>
                                        <li>64GB memory</li>
                                        <li>Up to 2TB SSD storage</li>
                                        <li>16-inch Retina display</li>
                                        <li>AMD Radeon Pro 5000M series graphics</li>
                                        <li>11 hrs battery life</li>
                                    </ul>
                                </span>
                                <span className="laptopSpecs">
                                    <ul>
                                        <a href="https://www.apple.com/mac/compare/?modelList=MacBook-Air-M1,MacBookPro-13-M1,iMac-5K" target="_blank">
                                            <h2>iMac 27-in (5K Retina)</h2> <ArrowUpwardIcon />
                                        </a>
                                        <li>8-core Intel Core i7 processor</li>
                                        <li>128GB memory</li>
                                        <li>4TB storage</li>
                                        <li>27” 5K Retina display</li>
                                        <li>AMD Radeon Pro 5300 with 4GB of GDDR6 memory</li>
                                        <li>Magic Keyboard</li>
                                    </ul>
                                </span>
                                <span className="keyboardSpecs">
                                    <ul>
                                        <h2>Keyboard & Mouse</h2>
                                        <li>Magic Keyboard or Magic Keyboard with Numeric Keypad</li>
                                        <li>Magic Mouse or Magic Trackpad</li>
                                    </ul>
                                </span>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>

        </>
    )
}

export default SetupMain
